import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

export const StyledTestField = styled(TextField)<{flex?: number | string}>`
    ${props => props.flex ? ('flex: ' + props.flex + ' !important') : ''}
`;
